import API from "./api";
import API_ROUTES from "./apiRoutes";

export const downloadResidentImportTemplate = async () => {
  const res = await API.get(API_ROUTES.import.residentTemplate);
  return res.data;
};

export const importResidentsFile = async (file, { dryRun = false, societyId } = {}) => {
  const formData = new FormData();
  formData.append("file", file);
  if (dryRun) formData.append("dry_run", "true");
  if (societyId) formData.append("society_id", String(societyId));

  const res = await API.post(API_ROUTES.import.residents, formData);
  return res.data;
};
